import { EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { UserLocation } from '@shared/models/user-location';

export const adapter: EntityAdapter<UserLocation> = createEntityAdapter<UserLocation>();
